var map = {
	"./click": 5615,
	"./click.json": 5615,
	"./generate_drawing": 1201,
	"./generate_drawing.json": 1201,
	"./hi": 2818,
	"./hi.json": 2818,
	"./locked": 539,
	"./locked.json": 539,
	"./love": 6696,
	"./love.json": 6696,
	"./move": 2587,
	"./move.json": 2587,
	"./sent": 585,
	"./sent.json": 585,
	"./zoom": 1011,
	"./zoom.json": 1011
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2703;